<div class="no_data_section">
  <div class="no_data_alignment">
    @if (pageData?.message) {
      <div class="no_data_avail">{{pageData.message}}</div>
    }
    @if (pageData?.description) {
      <div class="no_data_descript">{{pageData?.description}}</div>
    }
    <img [src]="imageConst.noDataFound" alt="no data found">
  </div>
</div>